@if (telematicsStore.loading(); as loading) {
  <app-modal-loading-section
    message="modals.errors.swap"
    [loading]="loading"
  ></app-modal-loading-section>
} @else if (swapPointAddress(); as address) {
  <section>
    <onyx-information-heading>
      {{ 'labels.plannedSwapPoint' | translate }}
    </onyx-information-heading>

    <onyx-data-widget
      [headingIcon]="{
        name: 'exchange-filled',
        size: 20,
        color: 'black',
      }"
    >
      <onyx-address heading [address]="address" format="full"></onyx-address>

      <span>
        {{ 'labels.id' | translate }}

        <onyx-link
          color="black"
          (click)="openSwapModal(relatedFleetSwap().uuid)"
        >
          {{ relatedFleetSwap().identifier }}
        </onyx-link>
      </span>
    </onyx-data-widget>
  </section>
}
